"use client";

import { cn } from "@/lib/utils";
import { Minus, Plus } from "lucide-react";
import { PortableText, PortableTextBlock } from "@portabletext/react";

export default function Question({
  index,
  question,
  answer,
  isOpen,
  onQuestionOpen,
}: {
  index: number;
  question: string;
  answer: PortableTextBlock[];
  isOpen: boolean;
  onQuestionOpen: (index: number) => void;
}) {
  return (
    <div className="mt-4 flex flex-col gap-2">
      <div>
        <div className="flex gap-2">
          <div
            className="bg-primary-light flex size-10 cursor-pointer items-center justify-center rounded-lg"
            onClick={() => onQuestionOpen(index)}
          >
            {isOpen ? <Minus /> : <Plus />}
          </div>
          <h3 className="flex items-center justify-center text-2xl font-semibold">
            {question}
          </h3>
        </div>
        <div
          className={cn("mt-2 max-h-max text-xl transition-all duration-300", {
            "h-0 overflow-hidden opacity-0": !isOpen,
            "h-100 opacity-100": isOpen,
          })}
        >
          <PortableText value={answer} />
        </div>
      </div>
    </div>
  );
}
